import { CdsLanguageModule } from '@cds/ng-core/lang';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CdsButtonModule } from '@cds/ng-web-components/button';

import { ErrorRoutingModule } from './error-routing.module';
import { TimeoutComponent } from './timeout/timeout.component';
import { PermissionErrorComponent } from './permission-error/permission-error.component';
import { ResponseErrorComponent } from './response-error/response-error.component';
import { DataAccessErrorComponent } from './data-access-error/data-access-error.component';
import { DeprecatedUrlErrorComponent } from './deprecated-url-error/deprecated-url-error.component';

@NgModule({
  imports: [
    CommonModule,
    CdsButtonModule,
    ErrorRoutingModule,
    CdsLanguageModule,
    TimeoutComponent,
    PermissionErrorComponent,
    ResponseErrorComponent,
    DataAccessErrorComponent,
    DeprecatedUrlErrorComponent,
  ],
})
export class ErrorModule {}
